"use client";

import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import Image from "next/image";
import styles from "./FooterSection.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import Logo from "@/app/assets/ftrlogo.svg";
import { HiArrowUpRight } from "react-icons/hi2";
import Payment from "@/app/assets/payment.svg";

import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaPinterestP,
  FaYoutube,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { PiTiktokLogoFill } from "react-icons/pi";
import Link from "next/link";

export default function FooterSection() {
  /* ======================
        EMAIL STATES
  ====================== */
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus("loading");

    try {
      const res = await fetch("/api/subscribe", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
   
      const data = await res.json();

      if (res.ok) {
        setStatus("success");
        setEmail("");
      } else {
        setStatus(data.error || "error");
      }
    } catch (err) {
      console.log(err);
      setStatus("error");
    }
  };

  return (
    <footer className={styles.footerWrapper}>
      <Container>
        {/* ================= TOP BAR WITH EMAIL ================= */}
        <Row className={styles.topRow}>
          <Col lg={6} md={12}>
            <h3 className={styles.topHeading}>
              Get the right solution in the right location.
            </h3>
            <p className={styles.topText}>
              Get a monthly snapshot of Temok&apos;s latest service updates,
              infrastructure improvements, behind-the-scenes enhancements, and
              expert picks from our hosting and cloud team.
            </p>
          </Col>

          <Col lg={6} md={12} className={styles.emailBox}>
            <form onSubmit={handleSubmit} className="w-100">
              <div className={`d-md-flex justify-content-md-end`}>
                {/* INPUT */}
                <div className={styles.inputWrapper}>
                  <span className={styles.emailIcon}>
                    <FontAwesomeIcon icon={faEnvelope} />
                  </span>

                  <Form.Control
                    type="email"
                    placeholder="Enter your email"
                    className={`${styles.emailInput} code-font`}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                {/* BUTTON */}
                <Button
                  className={`${styles.earlyBtn} code-font fw-semibold`}
                  type="submit"
                  disabled={status === "loading"}
                >
                  {status === "loading" ? "Please wait..." : "Subscribe Now"}
                  <HiArrowUpRight className={styles.btnArrowIcon} />
                </Button>
              </div>

              {/* STATUS MESSAGES */}
              {status === "success" && (
                <p className="text-success text-center mt-2">You are subscribed!</p>
              )}
              {status &&
                status !== "success" &&
                status !== "loading" && (
                  <p className="text-danger mt-2">{status}</p>
                )}
            </form>
          </Col>
        </Row>

        <hr className={styles.divider} />

        {/* ================= MAIN FOOTER GRID ================= */}
        <Row className={styles.mainFooter}>
          {/* LEFT COL */}
          <Col lg={3} md={12} sm={12} className={`${styles.leftCol} `}>
            <div className={`${styles.logoRow} mb-5`}>
              <Image src={Logo} alt="Temok" className={styles.logo} />
            </div>
            <p className={styles.leftText}>
              At Temok, we combine advanced
              <br />
              technology with exceptional service
              <br />
              to deliver reliable, scalable, & 
              <br />
              future-ready hosting solutions.
            </p>

            <div className={`${styles.paymentRow} `}>
              <Image src={Payment} className="img-fluid" alt="visa" />
            </div>
          </Col>

          {/* PARTNERSHIP */}
          <Col lg={3} md={6} sm={6} xs={12} className="ps-lg-5 mt-lg-0">
            <h5 className={`${styles.footerHeading} my-3`}>Partnership</h5>
            <ul className={styles.list}>
              <li>
                <Link href="/">
                  Reseller Partner Program
                </Link>
              </li>
              <li>
                <Link href="/whitelabel-managed-service-providers">
                  Whitelabel Managed Service
                </Link>
              </li>
              <li>
                <Link href="/affiliates-program">
                  Providers Partner Program
                </Link>
              </li>
              <li>
                <Link
                  href="https://www.shareasale.com/shareasale.cfm?merchantID=68808"
                  target="_blank"
                >
                  Affiliates Partner Program
                </Link>
              </li>
            </ul>
          </Col>

          {/* SOLUTIONS */}
          <Col lg={2} md={6} sm={6} xs={6}>
            <h5 className={`${styles.footerHeading} my-3`}>Solutions</h5>
            <ul className={styles.list}>
              <li>
                <Link href="https://temok.com/managed-cloud-hosting">
                  Managed Cloud Hosting
                </Link>
              </li>
              <li>
                <Link href="https://temok.com/dedicated-servers-usa">Servers</Link>
              </li>
              <li>
                <Link href="https://temok.com/linux-shared-hosting-usa">Hosting</Link>
              </li>
              <li>
                <Link href="https://temok.com/domain-registrations">Domains</Link>
              </li>
              <li>
                <Link href="https://temok.com/acronis-cyber-protect-cloud">
                  Acronis Cyber Protect Cloud
                </Link>
              </li>
              <li>
                <Link href="https://temok.com/buy-google-workspace">Collaboration Tools</Link>
              </li>
            </ul>
          </Col>

          {/* RESOURCES & COMPANY */}
          <Col lg={1} md={6} sm={6} xs={6}>
            <h5 className={`${styles.footerHeading} my-3`}>Resources</h5>
            <ul className={styles.list}>
              <li>
                <Link href="/blog">Blog</Link>
              </li>
              {/* <li>
                <Link href="/faq">FAQ</Link>
              </li> */}
            </ul>

            <h5 className={`${styles.footerHeading} mt-4`}>Company</h5>
            <ul className={styles.list}>
              <li>
                <Link href="https://temok.com/about-us">About us</Link>
              </li>
              <li>
                <Link href="https://temok.com/contact-us">Contact us</Link>
              </li>
            </ul>
          </Col>

          {/* SOCIAL */}
          <Col lg={3} md={6} sm={6} xs={6}>
            <h5 className={`${styles.footerHeading} my-3`}>Follow us</h5>

            <div className={styles.socialGridWrapper}>
              <Link
                href="https://www.facebook.com/TemokTechnologies"
                target="_blank"
                className={styles.socialBtn}
              >
                <FaFacebookF className={styles.socialIcon} /> Facebook
              </Link>

              <Link
                href="https://twitter.com/temokvoice"
                target="_blank"
                className={styles.socialBtn}
              >
                <FaXTwitter className={styles.socialIcon} /> X.com
              </Link>

              <Link
                href="https://www.linkedin.com/company/temoktechnologies"
                target="_blank"
                className={`${styles.socialBtn} ${styles.socialBtnActive}`}
              >
                <FaLinkedinIn className={styles.socialIcon} /> Linkedin
              </Link>

              <Link
                href="https://www.instagram.com/temoktechnologies/"
                target="_blank"
                className={styles.socialBtn}
              >
                <FaInstagram className={styles.socialIcon} /> Instagram
              </Link>

              <Link
                href="https://www.youtube.com/@TemokTechnologies"
                target="_blank"
                className={styles.socialBtn}
              >
                <FaYoutube className={styles.socialIcon} /> Youtube
              </Link>

              <Link
                href="https://www.pinterest.com/TemokTechnologies/"
                target="_blank"
                className={styles.socialBtn}
              >
                <FaPinterestP className={styles.socialIcon} /> Pinterest
              </Link>

              <Link
                href="https://www.tiktok.com/@temokvoice"
                target="_blank"
                className={styles.socialBtn}
              >
                <PiTiktokLogoFill className={styles.socialIcon} /> TikTok
              </Link>
            </div>
          </Col>
        </Row>

        <hr className={styles.divider} />

        {/* BOTTOM */}
        <Row className={styles.bottomBar}>
          <Col md={6} sm={12}>
            <p className={styles.copy}>© Temok. All rights reserved.</p>
          </Col>

          <Col md={6} sm={12} className={styles.bottomLinks}>
            <Link href="https://temok.com/privacy-policy">Privacy policy</Link>
            {/* <Link href="/terms-of-use">Refund policy</Link> */}
            <Link href="https://temok.com/terms-of-use">Terms of service</Link>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
